import { FaLinkedin, FaGlobe } from "react-icons/fa";

export function CapgeminiReferral() {
    return (
        <div className="ca-card p-4 flex flex-col items-center justify-between">
            {/* Logo */}
            <img
                src="https://companieslogo.com/img/orig/CAP.PA_BIG-cbc06f01.png?t=1720244491"
                alt="Capgemini Logo"
                className="w-2/3 object-contain mb-4"
            />

            {/* Text */}
            <div className="text-center space-y-2">
                <h2 className="text-lg font-bold text-gray-800 dark:text-white">
                    Find Your Opportunity 🚀
                </h2>
                <p className="text-sm text-gray-600 dark:text-gray-300">
                    Browse open positions at Capgemini and find the role that matches your
                    skills.
                </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col items-center gap-3 mt-4">
                <a
                    href="https://www.capgemini.com/in-en/careers/?page=1&size=11&country_code=in-en"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ca-btn-primary w-full text-center px-4 py-2"
                >
                    Explore Careers
                </a>

                <a
                    href="https://www.linkedin.com/in/pradeep-thombre/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-blue-700 dark:text-blue-400 hover:text-blue-900 dark:hover:text-blue-300 font-semibold text-sm"
                >
                    <FaLinkedin className="text-xl" />
                    DM Me for Referral
                </a>

                <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
                    Include job ID + resume when messaging for faster referral.
                </p>
            </div>
        </div>
    );
}

export function InfosysSpringboardPragati() {
    return (
        <div className="ca-card flex flex-col items-center justify-between overflow-hidden">
            {/* Logo */}
            <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5mPEdq0e5QbyLCMowpm9p0856aFs_AtKVFg&s"
                alt="Infosys Logo"
                className="object-contain rounded-t-2xl w-full max-h-100"
            />

            <div className="p-4 w-full">
                {/* Text Section */}
                <div className="text-center space-y-3">
                    <p className="text-gray-800 dark:text-gray-200">
                        Infosys Springboard Presents
                    </p>
                    <h2 className="text-lg font-bold text-gray-800 dark:text-white">
                        🚀 Pragati: Path to Future - Cohort 7 🚀
                    </h2>
                    <p className="text-sm text-gray-600 dark:text-gray-300">
                        A <strong>3-month career acceleration program</strong> (Oct–Dec 2025) to earn
                        <strong> certificates, badges,</strong> and spotlight features.
                    </p>
                    <p className="text-sm text-gray-700 dark:text-gray-300 font-medium">
                        📅 Registration Deadline: <strong>Oct 12, 2025</strong>
                        <br />
                        ✅ Selection Criteria: <strong>2 Courses + 1 Certification</strong>
                    </p>
                </div>

                {/* CTA Buttons */}
                <div className="flex flex-col items-center gap-3 mt-4">
                    <a
                        href="https://www.code-arena.in/jobs/68dd12d2ca781fbdb5110b22"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ca-btn-primary w-full text-center px-4 py-2"
                    >
                        Apply Now
                    </a>
                    <a
                        href="https://lnkd.in/gtEhd8Jt"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-green-700 dark:text-green-400 hover:text-green-900 dark:hover:text-green-300 font-semibold text-sm"
                    >
                        <FaGlobe className="text-xl" />
                        Explore More Internships
                    </a>

                    <p className="text-xs text-gray-500 dark:text-gray-400 text-center mt-2">
                        Tag your batchmates & share this post — let’s build the future together!
                    </p>
                </div>
            </div>
        </div>
    );
}

